module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_4.e3245533.png";